import { Fragment, memo, useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Navigation } from "swiper";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import Translate from "../../../../Components/Multilanguage/Translate";
import TrailerModal from "../../../../Components/Modals/TrailerModal";
import BannerUtil from "../util.jsx";
import { imageUrlCheck } from "../../../../utils/utils";

const TvShowHeroSlider = memo(({ data }) => {
  const themeSchemeDirection = '';
  const [toggler, setToggler] = useState(false);
  const [trailerLink, setTrailerLink] = useState();
  const projectInfo = useSelector((state) => state?.projectInfo?.value);
  const accessToken = useSelector((state) => state?.accessToken?.value);
  const { replaceImage, trailerButtonHandle, playClickHandler } = BannerUtil();
  
  const appInfo = {
    projectDetails: projectInfo,
    accessToken: accessToken,
  };

  return (
    <Fragment>
      <section className="hero-banner" role="region" aria-label="Show Banner">
        <div className="hero-banner__wrapper">
          <Swiper
            key={themeSchemeDirection}
            dir={themeSchemeDirection}
            navigation={{
              prevEl: ".hero-banner__button-prev",
              nextEl: ".hero-banner__button-next",
            }}
            slidesPerView={1.2}
            modules={[Navigation, Autoplay]}
            loop={true}
            autoplay={{
              delay: 4000,
              disableOnInteraction: false,
            }}
            centeredSlides={true}
            className="hero-banner__swiper"
            aria-label="Show  Banner Carousel"
          >
            {data?.shows?.map((item, index) => (
              <SwiperSlide key={index} aria-label={`TV Show Hero Slide ${index + 1}`}> 
                <div className="hero-banner__slide">
                  <div className="hero-banner__background">
                    {imageUrlCheck(item?.banner || item?.logo) ? (
                      <img
                        src={item?.banner}
                        onError={(error) => replaceImage(error)}
                        alt={item?.show_name ? `${item.show_name} banner` : "Banner"}
                      />
                    ) : (
                      <img
                        src={`${process.env.REACT_APP_IMAGE_URL}${item?.banner}`}
                        onError={(error) => replaceImage(error)}
                        alt={item?.show_name ? `${item.show_name} banner` : "Banner"}
                      />
                    )}
                  </div>

                  <div className="hero-banner__content" aria-label="Show Metadata">
                    <div className="hero-banner__grid">
                      <div className="hero-banner__col hero-banner__col--left">
                        <h1 className="hero-banner__title">
                          { (item?.image_title && imageUrlCheck(`${item.image_title}`)) ? (
                              <img src={`${item.image_title}`} alt={item.image_title || item.show_name} className="titleImage" />
                            ) : (
                              item?.show_name
                          )}
                        </h1>
                        <div className="hero-banner__info">
                          <span className="hero-banner__duration">
                            {item?.duration_text}
                          </span>
                        </div>
                        <p className="hero-banner__description" aria-label="Show Description">
                          {item?.synopsis}
                        </p>

                        <div className="hero-banner__button">
                          <div
                            className="hero-banner__play-link"
                            onClick={() => playClickHandler(item)}
                            role="button"
                            tabIndex={0}
                            aria-label={`Play ${item?.show_name}`}
                            onKeyDown={e => { if (e.key === 'Enter' || e.key === ' ') playClickHandler(item); }}
                          >
                            <span className="hero-banner__button-text">
                              <Translate textKey={"play_now"} />
                            </span>
                            <i className="fa-solid fa-play"></i>
                          </div>
                        </div>
                      </div>

                      {item?.teaser_vanity_url && (
                        <div className="hero-banner__col hero-banner__col--right">
                          <div className="hero-banner__trailer">
                          <Link
                            to="#"
                            className="hero-banner__trailer-link"
                            tabIndex={0}
                            aria-label={`Watch trailer for ${item?.show_name}`}
                          >
                            <svg
                              version="1.1"
                              viewBox="0 0 213.7 213.7"
                              xmlns="http://www.w3.org/2000/svg"
                              xmlnsXlink="http://www.w3.org/1999/xlink"
                              aria-hidden="true"
                            >
                            <polygon
                              className="triangle"
                              fill="none"
                              strokeWidth="7"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              strokeiterlimit="10"
                              points="73.5,62.5 148.5,105.8 73.5,149.1 "
                            ></polygon>
                            <circle
                              className="circle"
                              fill="none"
                              strokeWidth="7"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              strokeiterlimit="10"
                              cx="106.8"
                              cy="106.8"
                              r="103.3"
                            ></circle>
                            </svg>
                            <span
                              className="hero-banner__trailer-text"
                              onClick={() => trailerButtonHandle(item?.teaser_vanity_url, setTrailerLink, setToggler, toggler)}
                            >
                              <Translate textKey={"watch_trailer"} />
                            </span>
                          </Link>
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </SwiperSlide>
            ))}

            <div className="hero-banner__button-next" role="button" tabIndex={0} aria-label="Next Slide">
              <i className="fa fa-chevron-right" aria-hidden="true"></i>
            </div>
            <div className="hero-banner__button-prev" role="button" tabIndex={0} aria-label="Previous Slide">
              <i className="fa fa-chevron-left" aria-hidden="true"></i>
            </div>
          </Swiper>
        </div>
      </section>

      {toggler && trailerLink !== null && (
        <TrailerModal
          teaser={trailerLink}
          setIsTrailer={setToggler}
          appInfo={appInfo}
        />
      )}
    </Fragment>
  );
});

TvShowHeroSlider.displayName = TvShowHeroSlider;
export default TvShowHeroSlider;